import { asThemeConsumer } from "../../../theme/Theme";
import { joinClasses } from "../../../utils/Filters";
import { Button } from "../05-atoms/Button";
/**
 *
 */
export var FabPositions;
(function (FabPositions) {
    FabPositions["BOTTOM_RIGHT_NEGATIVE"] = "bottom-right-negative";
})(FabPositions || (FabPositions = {}));
/**
 * Fab is a specialization of the Button component, known as the Floating Action
 * Button.
 */
export var Fab = asThemeConsumer(Button, function (theme) { return (joinClasses("scl-h-shadow--huge", !!theme.position ? "scl-m-fab--".concat(theme.position) : undefined)); });
